import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useWishlistPageStream} from '../hooks/useWishlistPageStream';
import {WishlistDiscountSectionView} from './WishlistDiscountSectionView';

export const WishlistDiscountSection = () => {
  const {loadItems} = useWishlistPageStream();

  return (
    <DataFetcher
      request={loadItems}
      View={WishlistDiscountSectionView}
      Loading={() => null}
      Error={() => null}
    />
  );
};
